import React from 'react';

import { Alert, Box, CloseButton, List, Text } from '@zillow/constellation-10';

import stringHelper from '../../../utils/stringHelper';

type Props = {
  customerProblems: Array<string>;
};

const CustomerListingProblemsBanner = ({ customerProblems }: Props): JSX.Element | null => {
  if (customerProblems?.length > 0) {
    return (
      <Box css={{ marginBottom: '600' }} data-test="CustomerListingProblemsBanner">
        <Alert tone="warning" closeButton={<CloseButton />}>
          <React.Fragment>
            <Box css={{ marginBottom: '200' }}>
              <Text textStyle="body-bold">
                {stringHelper.pluralize(customerProblems.length, 'issue has', 'issues have')}
                &nbsp;been identified on this listing:
              </Text>
            </Box>
            <List.Root>
              {customerProblems.map((problem, problemIndex: number) => {
                return (
                  <List.Item key={`Customer-Problems-${problemIndex}`} css={{ paddingBlock: '0' }}>
                    {problem}
                  </List.Item>
                );
              })}
            </List.Root>
          </React.Fragment>
        </Alert>
      </Box>
    );
  }

  return null;
};

export default CustomerListingProblemsBanner;
